import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { GridColDef, GridValidRowModel } from '@mui/x-data-grid-pro';

export const useGetColumns = () => {
  const { t } = useTranslation('common');

  return useMemo<GridColDef<GridValidRowModel>[]>(
    () => [
      {
        headerName: t('name'),
        field: 'name',
        type: 'string',
        flex: 1,
        minWidth: 150
      },
      {
        headerName: t('code'),
        field: 'code',
        type: 'string',
        minWidth: 100
      },
      {
        headerName: t('description'),
        field: 'description',
        type: 'string',
        flex: 1,
        minWidth: 200
      },
      {
        headerName: t('qualifications'),
        field: 'requiredQualificationsDisplay',
        type: 'string',
        flex: 1,
        minWidth: 200
      },
      {
        headerName: t('allowedFunctions'),
        field: 'allowedFunctionsDisplay',
        type: 'string',
        flex: 1,
        minWidth: 200
      }
    ],
    [t]
  );
};
